import React from 'react';
import { Helmet } from 'react-helmet';
import { withRouter, RouteComponentProps } from 'react-router';
import { HomeUrl } from '../../constants/url';
import GoogleAnalysis from '../../utils/googleAnalysis';

class Title extends React.Component<RouteComponentProps> {
  onChangeClientState = info => {
    // GA
    if (info && info.title) {
      GoogleAnalysis.collectPageView(info.title);
    }
  };

  renderTitle() {
    const { location } = this.props;
    const homeTitle =
      'Autobest International Corp. - Successful Fuel Pump Manufacture';
    if (location.pathname === HomeUrl) {
      return homeTitle;
    }

    return location.pathname
      .replace('.html', '')
      .replace(
        /[^a-zA-Z0-9]+[a-zA-Z0-9]/g,
        match => ` ${match.charAt(match.length - 1).toUpperCase()}`
      )
      .trim();
  }

  render() {
    return (
      <Helmet onChangeClientState={this.onChangeClientState}>
        <title>{this.renderTitle()}</title>
      </Helmet>
    );
  }
}

export default withRouter(Title);
